"use strict";
import { gsap, Power3, Power0 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import * as animation from "../modules/_animation";
import Splide from "@splidejs/splide";
import anime from "animejs/lib/anime.es.js";
// import { spanWrapText } from "../modules/_spanWrapText";
animation.init();
gsap.registerPlugin(EaselPlugin, ScrollTrigger);

window.addEventListener("DOMContentLoaded", () => {
  const documentBody = document.querySelector("body");
  documentBody.classList.remove("fadeout");
});

// // splide 初期設定
function splide() {
  const kvOptions = {
    type: "fade",
    rewind: true,
    autoplay: true,
    // autoplay: "pause",
    arrows: false,
    speed: 2000,
    drag: false,
  };
  const kvSlider = new Splide(".index-kv-splide", kvOptions);
  const kvCover = new Splide(".index-kv-splide-cover", kvOptions);
  kvSlider.sync(kvCover);
  kvSlider.mount();
  kvCover.mount();
  const playPauseButton = document.querySelector(".splide-control-button");
  const buttonIcon = playPauseButton.querySelector(
    ".splide-control-button__icon"
  );
  const pauseButton = document.querySelector(".splide-control-button--pause");
  const playButton = document.querySelector(".splide-control-button--play");
  pauseButton.addEventListener("click", () => {
    kvSlider.Components.Autoplay.pause();
    kvCover.Components.Autoplay.pause();
    pauseButton.classList.add("is-active");
    playButton.classList.remove("is-active");
  });

  // 再生ボタンのクリックイベント
  playButton.addEventListener("click", () => {
    kvSlider.Components.Autoplay.play();
    kvCover.Components.Autoplay.play();
    pauseButton.classList.remove("is-active");
    playButton.classList.add("is-active");
  });
}

// kvPin
const pinSplide = document.querySelectorAll(".splide");
pinSplide.forEach((item) => {
  ScrollTrigger.create({
    trigger: ".container",
    pin: item,
    // markers: true,
    pinSpacing: false,
    endTrigger: ".index-about",
    end: "bottom bottom",
    scrub: true,
  });
});
// Pin
const pinPieced = document.querySelector(
  ".index-kv-floating__obj--pierced-square"
);
ScrollTrigger.create({
  target: pinPieced,
  trigger: ".index-about",
  start: "top center",
  endTrigger: ".footer",
  end: "top bottom",
  toggleClass: {
    targets: pinPieced,
    className: "pined",
  },
});

// 手書きアニメ
function handWriting() {
  const writingTargets = document.querySelectorAll(".index-kv-title__text");
  writingTargets.forEach((item) => {
    item.style.opacity = "1";
  });
  const Writing = anime({
    easing: "easeOutSine",
    // direction: "alternate",
    targets: document.querySelectorAll(".wrtpath"),
    duration: (el, i) => {
      if (el.classList.contains("path-trace")) {
        // 「世界が動き出す」部分のなぞる部分用
        return 1800;
      }
      return 120;
    },

    strokeDashoffset: [anime.setDashoffset, 0],
    delay: (el, i) => {
      return i * 120;
    },
  });
}
gsap.utils.toArray(".js-parallax").forEach((wrap) => {
  const y = wrap.getAttribute("data-y") || -100;

  gsap.to(wrap, {
    y: y,
    scrollTrigger: {
      trigger: wrap,
      start: "top bottom",
      end: "bottom top",
      scrub: 0.3,
      //markers: true
    },
  });
});

// // .is-opening
const kvMaskText = document.querySelector(".index-kv-second-text");
window.addEventListener("load", () => {
  const tl = gsap.timeline({ repeat: -1, repeatDelay: 0.5 }); // はじめに初期化
  new Promise((resolve) => {
    gsap.utils
      .toArray(".index-kv-floating__obj.is-opening")
      .forEach((objItem) => {
        gsap.fromTo(
          ".index-kv-floating__obj.is-opening",
          0.5,
          {
            autoAlpha: 0,
          },
          {
            autoAlpha: 1,
            stagger: {
              each: 0.3,
            },
          }
        );
      });
  }, 100);
  setTimeout(() => {
    const kvFloating = document.querySelectorAll(".index-kv-floating__obj");
    kvFloating.forEach((item) => {
      item.classList.remove("is-opening");
    });
    // kvFloating.forEach((item) => {
    //   item.classList.add("is-anime");
    // });
  }, 1600);
  setTimeout(() => {
    // kvMaskText.classList.add("is-start");
  }, 2200);
  setTimeout(() => {
    handWriting();
    // kvMaskText.classList.add("is-start");
  }, 1600);
  setTimeout(() => {
    const kvCarousel = document.querySelectorAll(".splide__track");
    kvCarousel.forEach((item) => {
      item.classList.add("is-view");
    });
    splide();
  }, 2800);
  setTimeout(() => {
    document
      .querySelector(".index-kv-title__arrow")
      .classList.add("is-ignition");
    document.querySelector(".kv-mintext").classList.add("is-start");
  }, 5000);
  new Promise((resolve) => {
    gsap.utils
      .toArray(".index-kv-floating__obj.is-opening")
      .forEach((objItem) => {
        gsap.fromTo(
          ".index-kv-floating__obj.is-opening",
          0.5,
          {
            autoAlpha: 0,
          },
          {
            autoAlpha: 1,
            stagger: {
              each: 0.3,
            },
          }
        );
      });
  }, 100);
});
